module.exports = __webpack_public_path__ + "img/redemptions.7b4f8ec4.svg";